import { ScreenNames } from '@space-core/datahub'
import useMembership from '@space-shell/common/hooks/useMembership'
import { BaseNames } from '@space-shell/core/router/constants'
import { useTranslation } from 'react-i18next'

const useScreenName = () => {
  const { membershipSlug } = useMembership()
  const {
    i18n: { language }
  } = useTranslation()

  const isHomeLocation =
    window.location.pathname === BaseNames.communityHomePage(membershipSlug, language.toLowerCase())

  const isProductLocation =
    window.location.pathname ===
    BaseNames.communityProductsPage(membershipSlug, language.toLowerCase())

  const isCommunityFeedLocation = window.location.pathname.match(
    new RegExp(`^\\/${language.toLowerCase()}\\/club\\/${membershipSlug}\\/community\\/([0-9]+)$`)
  )

  const isCommunityPostDetailLocation = window.location.pathname.match(
    new RegExp(
      `^\\/${language.toLowerCase()}\\/club\\/${membershipSlug}\\/community\\/([0-9]+)\\/post\\/([0-9]+)$`
    )
  )

  if (isHomeLocation) {
    return ScreenNames.HOME_MEMBERSHIP_CONSUMER
  }

  if (isProductLocation) {
    return ScreenNames.PRODUCT_LIST_MEMBERSHIP_CONSUMER
  }

  if (isCommunityFeedLocation) {
    return ScreenNames.COMMUNITY_FEED
  }

  if (isCommunityPostDetailLocation) {
    return ScreenNames.COMMUNITY_POST_DETAIL
  }

  return ScreenNames.OTHERS
}

export default useScreenName
